import { Card } from "@/components/ui/card";
import { getValidHttpUrl } from "@/lib/url";

interface SlackPreviewProps {
  metaTags: {
    og_title?: string;
    og_description?: string;
    og_image?: string;
    og_url?: string;
    og_site_name?: string;
  };
}

export default function SlackPreview({ metaTags }: SlackPreviewProps) {
  const { og_title, og_description, og_image, og_url, og_site_name } = metaTags;
  const imageUrl = getValidHttpUrl(og_image);

  let hostname = "";
  try {
    if (og_url) {
      hostname = new URL(og_url).hostname.replace("www.", "");
    }
  } catch {
    // Invalid URL, leave hostname empty
  }

  return (
    <Card className="w-full max-w-lg gap-0 rounded-lg border p-4 py-4 shadow-md">
      <div className="border-l-4 border-gray-300 pl-3 dark:border-gray-600">
        <div className="flex items-center gap-1.5">
          <span className="inline-block h-4 w-4 flex-shrink-0 rounded bg-gray-300 dark:bg-gray-600" aria-hidden />
          <span className="text-sm font-bold text-gray-900 dark:text-gray-100">{og_site_name || hostname}</span>
        </div>
        <p className="mt-1 text-sm font-bold text-[#1264a3] dark:text-[#4c9fd6]">{og_title || "No title found"}</p>
        {og_description && (
          <p className="mt-0.5 line-clamp-2 text-sm text-gray-700 dark:text-gray-300">{og_description}</p>
        )}
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={og_title ?? ""}
            className="mt-2 aspect-[1.91/1] w-full max-w-sm rounded-lg border object-cover"
          />
        ) : (
          <div className="mt-2 flex h-40 w-full max-w-sm items-center justify-center rounded-lg bg-gray-100 dark:bg-gray-800">
            <p className="text-sm text-gray-500 dark:text-gray-300">No image available</p>
          </div>
        )}
      </div>
    </Card>
  );
}
